/**
 * Pure string-based HTML entity decoder.
 * Matches the previous decodeHtmlMessage implementation.
 */
export function decodeHtmlMessage(message: string): string {
	return message
		.replaceAll(/&amp;/g, '&')
		.replaceAll(/&lt;/g, '<')
		.replaceAll(/&gt;/g, '>')
		.replaceAll(/&quot;/g, '"')
		.replaceAll(/&#039;/g, "'");
}

/**
 * Browser-based HTML decoder that also leverages the pure decoder.
 * Matches the previous decodeHtmlTextMessage behavior.
 */
export function decodeHtmlTextMessage(message: string): string {
	const unescaped = decodeHtmlMessage(message);

	const txt = document.createElement('textarea');
	txt.innerHTML = unescaped;
	return txt.value;
}
